// Gerado a partir das LPs atuais (Wix) — conteúdo/copy/imagens fiéis ao original.
import type { CertificacaoData } from "./types";
import { CERT_SLUGS } from "./config";
import { certOfertaLp, certCheckoutUrlLp } from "./oferta";

export const CERT_DATA: Record<string, CertificacaoData> = {
  "lombar": {
    "slug": "lombar",
    "logo": "/__l5e/assets-v1/e317052d-25f6-4549-aec4-dd7e7a6ef8f2/cert-lombar-logo.webp",
    "heroTitle": [
      "Domine todas as etapas de Avaliação e Tratamento"
    ],
    "heroSub": [
      "Um curso 100% online, com 60h, repleto de",
      "casos clínicos reais e aulas práticas"
    ],
    "ctaHero": "MATRICULE-SE AGORA",
    "cards": [
      {
        "img": "/__l5e/assets-v1/1a9c0f10-83ec-47d0-a66a-1ff358035f79/cert-9ff0ffe5a7.webp",
        "lines": [
          "Aprofunde seu raciocínio",
          "com o que há de mais novo na ciência sobre Dor Lombar"
        ]
      },
      {
        "img": "/__l5e/assets-v1/30dd4f66-6687-4c04-a707-ecd957421dea/cert-bed1599aa4.webp",
        "lines": [
          "Professores altamente",
          "capacitados e experientes",
          "em Coluna Lombar"
        ]
      },
      {
        "img": "/__l5e/assets-v1/28b1b488-e859-47e1-8cd4-c249d3b4b378/cert-ab3061d575.webp",
        "lines": [
          "Exemplos práticos",
          "e vídeos de como",
          "atender seu paciente"
        ]
      },
      {
        "img": "/__l5e/assets-v1/83d1bddb-f778-4731-90cb-646252732c03/cert-3022f504c9.webp",
        "lines": [
          "Da Teoria à Prática",
          "com discussão de",
          "Casos Clínicos reais",
          "Um passo a passo para você atender desde os casos mais comuns até os mais complexos"
        ]
      }
    ],
    "passoTitle": null,
    "stats": [
      {
        "valor": "05",
        "label": "Módulos"
      },
      {
        "valor": "60H",
        "label": "Conteúdos"
      },
      {
        "valor": "80%",
        "label": "Conteúdo Prático"
      }
    ],
    "destaque": [
      "Domine técnicas",
      "comprovadas",
      "cientificamente"
    ],
    "ctaMid": null,
    "mockupSmartphone": "/__l5e/assets-v1/0cd7644b-7473-4817-ad77-6731f0c53ff1/cert-f884256ecd.webp",
    "expertTitle": null,
    "benefits": [
      {
        "icon": "/__l5e/assets-v1/6a07b1f0-be5c-4ffc-802d-820691898dc2/cert-1be094f95e.webp",
        "iconAlt": "Livro.png",
        "lines": [
          "Melhore seu repertório",
          "de técnicas baseadas",
          "em evidências"
        ]
      },
      {
        "icon": "/__l5e/assets-v1/bf42a964-e035-40c6-bbf3-60b06ee97c6a/cert-94e5f44572.webp",
        "iconAlt": "Prancheta.png",
        "lines": [
          "Atenda com eficácia",
          "qualquer paciente",
          "com Dor Lombar"
        ]
      }
    ],
    "fundo": "/__l5e/assets-v1/47bac1c0-157e-40b8-b374-c9425aa87901/cert-85f2b596c2.webp",
    "comoFuncionaTitle": [
      "Como funciona",
      "a Certificação?"
    ],
    "comoFuncionaText": "É um curso 100% online, com aulas gravadas, onde ensinaremos o que há de mais moderno no tratamento da Coluna Lombar. Um treinamento recheado de aplicações clínicas e aulas práticas.",
    "comoFuncionaImg": "/__l5e/assets-v1/4a052fed-612c-4530-aaba-b6dbb29ddede/cert-e7fd171b8d.webp",
    "aprenderTitle": [
      "O que você vai",
      "aprender?"
    ],
    "modulos": [
      {
        "titulo": "Módulo 1 - Conceitos Gerais da Coluna Lombar",
        "itens": [
          "Anatomia e Biomecânica",
          "Epidemiologia na Coluna Lombar",
          "Fatores de Risco e Prognóstico",
          "Existe Dor na Coluna Vertebral?",
          "A Postura Importa?"
        ]
      },
      {
        "titulo": "Módulo 2 - Avaliação da Coluna Lombar",
        "itens": [
          "Anamnese",
          "Exame Físico",
          "Avaliação da Dor Baseada em Mecanismos",
          "Instrumentos de Avaliação e Exame de Imagens",
          "Sistema de Bandeiras: O que é uma doença grave?"
        ]
      },
      {
        "titulo": "Módulo 3 - Intervenções na Coluna Lombar",
        "itens": [
          "Raciocínio Clínico: Dor Lombar Aguda x Crônica",
          "Educação em dor",
          "Prescrição de Exercícios",
          "Terapia Manuais e Técnicas Coadjuvantes",
          "Terapias Comportamentais (CFT/ Imagética Motora)"
        ]
      },
      {
        "titulo": "Módulo 4 - Patologias Específicas e Raras",
        "itens": [
          "Hérnia de Disco e Radiculopatia",
          "Escolioses",
          "Espondilolistese / Espondilólise",
          "Tuberculose Vertebral / Espondilite Anquilosante",
          "Estenose Vertebral / Malformações Congênitas"
        ]
      },
      {
        "titulo": "Módulo 5 - Traumatologia e Cirurgias da Coluna Lombar",
        "itens": [
          "Intervenções Minimamente Invasivas",
          "Tipos de Cirurgias",
          "Infecções",
          "Reabilitação no Pós-Operatório e Sd. da Falha Cirúrgica",
          "Fraturas na Coluna Lombar"
        ]
      }
    ],
    "pilares": [],
    "ctaPilares": null,
    "depoimentos": [
      {
        "quote": "A expertise dos professores, com casos reais de pacientes, a fala calma e pausada, e a boa didática me prendeu a essa certificação como em uma série de filmes. O conteúdo foi denso porém o senti leve e profissional",
        "foto": "/__l5e/assets-v1/c0ca0f6f-de87-4500-99a5-c36c8bc5852d/cert-5bc538c0e2.webp",
        "nome": "@crismourah",
        "role": "Fisioterapeuta"
      },
      {
        "quote": "A certificação foi fundamental para entender o imenso mundo das alterações da coluna lombar, contemplando desde origens traumáticas, idiopáticas agudas e crônicas, com o que há de mais moderno em evidencias de alto nível.",
        "foto": "/__l5e/assets-v1/74a2fd5e-96e4-4dcb-8f68-b91724c51297/cert-b908457013.webp",
        "nome": "@leandro\\_bruno\\_88",
        "role": "Fisioterapeuta"
      }
    ],
    "seloAutoridade": "/__l5e/assets-v1/7c05d88a-ad4d-4aa1-9210-fc00ee804e14/cert-51584792d8.webp",
    "autoridadeTitle": "Aprenda com quem domina o assunto",
    "autoridadeSub": "Conheça o corpo docente com professores referência na área",
    "ofertaTitle": "Ofereça o melhor tratamento para os seus pacientes",
    "professores": [
      {
        "foto": "/__l5e/assets-v1/d3b46bac-2b4b-497b-a38f-a1e6bbe98f72/cert-eddaad1d21.webp",
        "nome": "Isadora Oliveira",
        "role": "Fisioterapeuta",
        "bio": [
          "Fisioterapeuta Equipe CineticsPhysio (Campinas-SP)",
          "Mestre",
          "Reabilitação e Desempenho Funcional pela FMRP- USP - 2016",
          "Doutora",
          "Ciências da Saúde do Hospital Israelita Albert Einstein - 2021",
          "Docente da Pós de Dor e Ortopedia Multiprofissional do Einstein",
          "Produtora de conteúdo do Portal Fisio em Ortopedia"
        ]
      },
      {
        "foto": "/__l5e/assets-v1/b67c5754-8382-4117-b5d2-5bbc3c9690ee/cert-0ffab5bdfa.webp",
        "nome": "Renato Soares",
        "role": "Fisioterapeuta",
        "bio": [
          "Docente da Universidade de Taubaté (UNITAU)",
          "Mestre",
          "Ciências da Reabilitação - UNIFESP",
          "2001",
          "Doutor",
          "Biodinâmica do Movimento Humano - USP 2007",
          "Sócio-proprietário do Grupo Equality",
          "Especialista em Fisioterapia Ortopédica e Traumatológica"
        ]
      },
      {
        "foto": "/__l5e/assets-v1/ec0b640e-1eac-48a8-822d-8d35c60dfe97/cert-9273cefe6b.webp",
        "nome": "Murilo DeMarco",
        "role": "Fisioterapeuta",
        "bio": [
          "Possui formações em Osteopatia, Metódo Mckenzie,",
          "Sistema de Subgrupos da Coluna, Conceito Mulligan, Maitland, Mobilização Neural entre outros",
          "Mestre",
          "Fisioterapia - UDESC 2020",
          "Empreendedor",
          "Idealizador do programa @fisioecoluna"
        ]
      },
      {
        "foto": "/__l5e/assets-v1/4183b6e0-4782-45fb-980e-458915c0e6f9/cert-08e47e52da.webp",
        "nome": "Guilherme Paiva",
        "role": "Fisioterapeuta",
        "bio": [
          "Aprimoramento em Orto e Trauma pelo HC-FMRP-USP",
          "Mestre",
          "Ciências pela FMRP - USP 2022",
          "Empreendedor",
          "Sócio-proprietário da Clínica \"Na Fisio\" e idealizador do perfil @guidaimagetica",
          "Membro do Grupo do Ombro USP-RP e Head de Treinamento da FEO",
          "Formação em Imagética Motora Graduada na Noruega pelo Noigroup"
        ]
      }
    ],
    "mockupTablet": "/__l5e/assets-v1/cda1086e-f1f3-4957-9026-1c593fd9ca53/cert-7c55b3be59.webp",
    "selo2anos": "/__l5e/assets-v1/475ce0d8-7a0b-49bb-8481-51a4e45c0529/cert-ce4667b52b.webp",
    "preco": [
      "DE R$697 POR",
      "R$ 397",
      "ou 12x R$41,06"
    ],
    "promo": [],
    "checkoutLabel": "MATRICULE-SE AGORA",
    "checkoutUrl": "https://chk.eduzz.com/G92VQY5Z9E?cupom=300OFF&df=1&pf=1",
    "bonus": [
      "BÔNUS: Ao se matricular você garante R$500,00 de desconto em todas as outras Certificações da FEO.",
      "Desconto aplicado direto no carrinho. Não perca essa chance de mudar sua carreira!"
    ],
    "faqSupport": [
      "Ainda precisa de ajuda?"
    ],
    "suporteLabel": "CONTATE-NOS",
    "suporteUrl": "https://api.whatsapp.com/send?1=pt_BR&phone=5511930316779",
    "faqImg": "/__l5e/assets-v1/92567dc4-97ff-48d2-b5dc-5c3a18f92f72/cert-871f9f89a1.webp",
    "faq": [
      {
        "q": "Por quanto tempo terei acesso à certificação?",
        "a": "O conteúdo completo da Certificação ficará disponível por dois anos contados a partir do momento da sua inscrição."
      },
      {
        "q": "A certificação é somente para fisioterapeutas?",
        "a": "Sim, a certificação foi pensada para fisioterapeutas que já atuam na área e trabalham com pacientes com dor lombar."
      },
      {
        "q": "Como posso tirar dúvidas com os professores?",
        "a": "Você poderá deixar suas dúvidas em nossa plataforma de ensino. As suas perguntas serão respondidas por nossos professores!"
      },
      {
        "q": "Como será a entrega do certificado?",
        "a": "O certificado será entregue após você realizar todas às aulas da Certificação. Você poderá retirá-lo dentro da nossa plataforma de ensino."
      },
      {
        "q": "O conteúdo da Certificação é o mesmo que estão nos cursos da Star?",
        "a": "Não, o conteúdo da Certificação é exclusivo e com uma visão aprofundada para transformar o fisioterapeuta em \"expert\" na temática. São 60h de conteúdos dedicados ao aprofundamento em Coluna Lombar, distribuídas em 5 módulos."
      },
      {
        "q": "Sou estudante, posso fazer a Certificação?",
        "a": "Você pode fazer a Certificação. No entanto, ela é indicada para fisioterapeutas que têm uma demanda de dor lombar no consultório. © 2024 Fisio em Ortopedia. Todos os direitos reservados."
      }
    ],
    "heroBg": "/__l5e/assets-v1/1402b17b-b63b-41ad-9284-c0be00e5e8bb/quadril-background.webp",
    "comoFuncionaNaSecaoBranca": true,
    "benefitsGrid": [
      {
        "icon": "stethoscope",
        "title": "CONQUISTE SEGURANÇA PARA FAZER UMA AVALIAÇÃO COMPLETA DA COLUNA LOMBAR"
      },
      {
        "icon": "book-open",
        "title": "MELHORE SEU REPERTÓRIO COM TÉCNICAS BASEADAS EM EVIDÊNCIAS"
      },
      {
        "icon": "award",
        "title": "TORNE-SE REFERÊNCIA NO TRATAMENTO DAS PATOLOGIAS DA COLUNA LOMBAR"
      },
      {
        "icon": "heart-pulse",
        "title": "ATENDA COM EFICÁCIA SEUS PACIENTES E OFEREÇA UM TRATAMENTO COMPLETO"
      }
    ]
  },
  "cervical": {
    "slug": "cervical",
    "logo": "/__l5e/assets-v1/115be0b6-7550-4cae-a698-47e2311cefd8/cert-cervical-logo.webp",
    "heroTitle": [
      "Domine todas as etapas de Avaliação e Tratamento"
    ],
    "heroSub": [
      "Um curso 100% online, com 60h, repleto de",
      "casos clínicos reais e aulas práticas"
    ],
    "ctaHero": "MATRICULE-SE AGORA",
    "cards": [
      {
        "img": "/__l5e/assets-v1/bb88b7bf-1c99-469e-bdfb-943ea80b6e9d/cert-f2afc9da7b.webp",
        "lines": [
          "Aprofunde seu raciocínio",
          "multidimensional sobre",
          "pacientes com Dor Cervical"
        ]
      },
      {
        "img": "/__l5e/assets-v1/aa1aa0fa-9be3-40f5-920d-ecf12f01cffc/cert-30637ded85.webp",
        "lines": [
          "Profissionais altamente",
          "capacitados e experientes",
          "em Coluna Cervical"
        ]
      },
      {
        "img": "/__l5e/assets-v1/c494d0e7-23e4-4a6e-bb7d-4c608bb9d106/cert-0a5070fef4.webp",
        "lines": [
          "Exemplos práticos",
          "e vídeos de como",
          "atender seu paciente"
        ]
      },
      {
        "img": "/__l5e/assets-v1/8993a0d5-3d05-4d75-b992-4a1c9679b474/cert-a8f1a33f86.webp",
        "lines": [
          "Da Teoria à Prática",
          "com discussão de",
          "Casos Clínicos reais",
          "Um passo a passo para você atender desde os casos mais comuns até os mais complexos"
        ]
      }
    ],
    "passoTitle": null,
    "stats": [
      {
        "valor": "05",
        "label": "Módulos"
      },
      {
        "valor": "60H",
        "label": "Conteúdos"
      },
      {
        "valor": "80%",
        "label": "Conteúdo Prático"
      }
    ],
    "destaque": [
      "Domine técnicas",
      "comprovadas",
      "cientificamente"
    ],
    "ctaMid": "TENHO INTERESSE",
    "mockupSmartphone": "/__l5e/assets-v1/d3608889-e34a-4209-978f-247af21da8ea/cert-25136d94ba.webp",
    "expertTitle": null,
    "benefits": [
      {
        "icon": "/__l5e/assets-v1/6c10ea61-93a1-42da-b301-ebd6dd2f223f/cert-bd2198facc.webp",
        "iconAlt": "Escudo.png",
        "lines": [
          "Conquiste segurança",
          "para avaliar e tratar",
          "seus pacientes"
        ]
      },
      {
        "icon": "/__l5e/assets-v1/6a07b1f0-be5c-4ffc-802d-820691898dc2/cert-1be094f95e.webp",
        "iconAlt": "Livro.png",
        "lines": [
          "Melhore seu repertório",
          "de técnicas baseadas",
          "em evidências"
        ]
      },
      {
        "icon": "/__l5e/assets-v1/bf42a964-e035-40c6-bbf3-60b06ee97c6a/cert-94e5f44572.webp",
        "iconAlt": "Prancheta.png",
        "lines": [
          "Atenda com eficácia",
          "qualquer paciente",
          "com Dor Cervical"
        ]
      }
    ],
    "fundo": "/__l5e/assets-v1/0269f2e2-6743-4e45-8eb7-4e260694b599/cert-a86ba934c9.webp",
    "comoFuncionaTitle": [
      "Como funciona",
      "a Certificação?"
    ],
    "comoFuncionaText": "É um curso 100% online, com aulas gravadas, onde ensinaremos o que há de mais moderno no tratamento da Coluna Cervical. Um treinamento recheado de aplicações clínicas e aulas práticas.",
    "comoFuncionaImg": "/__l5e/assets-v1/a059543e-b48f-40bb-ad5d-9d09aa47437c/cert-1c1122836b.webp",
    "aprenderTitle": [
      "O que você vai",
      "aprender?"
    ],
    "modulos": [
      {
        "titulo": "Módulo 1 - Conceitos Gerais da Coluna Cervical",
        "itens": [
          "Anatomia e Biomecânica",
          "Epidemiologia na Coluna Cervical",
          "Fatores de Risco e Prognóstico",
          "Text Neck: A vilã é a Postura?"
        ]
      },
      {
        "titulo": "Módulo 2 - Avaliação da Coluna Cervical",
        "itens": [
          "Anamnese",
          "Exame Físico",
          "Avaliação da Dor Baseada em Mecanismos",
          "Instrumentos de Avaliação e Exame de Imagens",
          "Sistema de Bandeiras: O que é uma doença grave?"
        ]
      },
      {
        "titulo": "Módulo 3 - Intervenções na Coluna Cervical",
        "itens": [
          "Raciocínio Clínico: Como planejar meu tratamento",
          "Educação em dor",
          "Prescrição de Exercícios",
          "Terapia Manuais e Técnicas Coadjuvantes",
          "Terapias Comportamentais (CFT/ Imagética Motora)"
        ]
      },
      {
        "titulo": "Módulo 4 - Patologias Específicas e Raras",
        "itens": [
          "Hérnia de Disco e Radiculopatia",
          "Relação entre DTM x Cervical",
          "Cefaléia / Tontura Cervicogênica / Whiplash",
          "Tuberculose Vertebral / Espondilite Anquilosante",
          "Malformações Congênitas"
        ]
      },
      {
        "titulo": "Módulo 5 - Traumatologia e Cirurgias da Coluna Cervical",
        "itens": [
          "Intervenções Minimamente Invasivas",
          "Tipos de Cirurgias",
          "Reabilitação da Coluna Vertebral no Pós-Operatório",
          "Fraturas na Coluna Cervical"
        ]
      }
    ],
    "pilares": [],
    "ctaPilares": null,
    "depoimentos": [
      {
        "quote": "Muito grato de ter chegado ao Fisio em Ortopedia, pois lá encontrei professores de ponta, didática incrível e conhecimentos inovadores.",
        "foto": "/__l5e/assets-v1/6d0321c6-91b9-47da-9ff1-5b1090e1298f/cert-56d17fa34f.webp",
        "nome": "Bruno Benatti",
        "role": "Fisioterapeuta"
      },
      {
        "quote": "Um marco na fisioterapia brasileira. Conteúdos de excelente qualidade, disponíveis de forma prática para qualificar nossa atuação.",
        "foto": "/__l5e/assets-v1/72d50416-9934-4ca6-ae57-50fb171f644e/cert-946d91d5aa.webp",
        "nome": "Jéssica Béda",
        "role": "Fisioterapeuta"
      }
    ],
    "seloAutoridade": "/__l5e/assets-v1/f2084bc0-2f83-45f7-a4d4-369f0a7f2965/cert-11bdc56db0.webp",
    "autoridadeTitle": "Aprenda com quem domina o assunto",
    "autoridadeSub": "Descubra como os fisioterapeutas que você mais admira estão fazendo para que você se torne especialista este ano",
    "ofertaTitle": "Ofereça o melhor tratamento para os seus pacientes",
    "professores": [
      {
        "foto": "/__l5e/assets-v1/239f7755-b4c1-44dc-8ab5-a2ba030a1d83/cert-cfc2581fbe.webp",
        "nome": "Isadora Oliveira",
        "role": "Fisioterapeuta",
        "bio": [
          "Fisioterapeuta Equipe CineticsPhysio (Campinas-SP)",
          "Mestre",
          "Reabilitação e Desempenho Funcional pela FMRP- USP - 2016",
          "Doutora",
          "Ciências da Saúde do Hospital Israelita Albert Einstein - 2021",
          "Docente da Pós de Dor e Ortopedia Multiprofissional do Einstein",
          "Produtora de conteúdo do Portal Fisio em Ortopedia"
        ]
      },
      {
        "foto": "/__l5e/assets-v1/aedc7568-6105-483f-90a9-a47d816070cf/cert-29df2f38e0.webp",
        "nome": "Renato Soares",
        "role": "Fisioterapeuta",
        "bio": [
          "Docente da Universidade de Taubaté (UNITAU)",
          "Mestre",
          "Ciências da Reabilitação - UNIFESP",
          "2001",
          "Doutor",
          "Biodinâmica do Movimento Humano - USP 2007",
          "Sócio-proprietário do Grupo Equality",
          "Especialista em Fisioterapia Ortopédica e Traumatológica"
        ]
      },
      {
        "foto": "/__l5e/assets-v1/aa3d007c-00f7-4291-8518-f7b44b889267/cert-63f3032ce0.webp",
        "nome": "Murilo DeMarco",
        "role": "Fisioterapeuta",
        "bio": [
          "Possui formações em Osteopatia, Metódo Mckenzie,",
          "Sistema de Subgrupos da Coluna, Conceito Mulligan, Maitland, Mobilização Neural entre outros",
          "Mestre",
          "Fisioterapia - UDESC 2020",
          "Empreendedor",
          "Idealizador do programa @fisioecoluna"
        ]
      },
      {
        "foto": "/__l5e/assets-v1/dd52d63d-487f-4049-9921-2ec76228c9d7/cert-f38e4f8ba7.webp",
        "nome": "Guilherme Paiva",
        "role": "Fisioterapeuta",
        "bio": [
          "Aprimoramento em Orto e Trauma pelo HC-FMRP-USP",
          "Mestre",
          "Ciências pela FMRP - USP 2022",
          "Empreendedor",
          "Sócio-proprietário da Clínica \"Na Fisio\" e idealizador do perfil @guidaimagetica",
          "Membro do Grupo do Ombro USP-RP e Head de Treinamento da FEO",
          "Formação em Imagética Motora Graduada na Noruega pelo Noigroup"
        ]
      }
    ],
    "mockupTablet": "/__l5e/assets-v1/7726bbd8-9803-4198-adaf-fe1fa0e0aac7/cert-8ec5076f7b.webp",
    "selo2anos": "/__l5e/assets-v1/ce5a1d87-bfd9-44ab-a99e-5339dab922dd/cert-ce63bb991a.webp",
    "preco": [
      "DE R$697 POR",
      "R$ 397",
      "ou 12x R$41,06"
    ],
    "promo": [],
    "checkoutLabel": "MATRICULE-SE",
    "checkoutUrl": "https://chk.eduzz.com/2439321?cupom=300OFF&df=1&pf=1",
    "bonus": [
      "BÔNUS: Ao se matricular você garante R$500,00 de desconto em todas as outras Certificações da FEO.",
      "Desconto aplicado direto no carrinho. Não perca essa chance de mudar sua carreira!"
    ],
    "faqSupport": [
      "Ainda precisa de ajuda? Entre em",
      "contato com o suporte ao cliente!"
    ],
    "suporteLabel": "CONTATE-NOS",
    "suporteUrl": "https://api.whatsapp.com/send?1=pt_BR&phone=5511930316779",
    "faqImg": "/__l5e/assets-v1/92567dc4-97ff-48d2-b5dc-5c3a18f92f72/cert-871f9f89a1.webp",
    "faq": [
      {
        "q": "Por quanto tempo terei acesso à certificação?",
        "a": "O conteúdo completo da Certificação ficará disponível por dois anos contados a partir do momento da sua inscrição."
      },
      {
        "q": "A certificação é somente para fisioterapeutas?",
        "a": "Sim, a certificação foi pensada para fisioterapeutas que já atuam na área e trabalham com pacientes com dor cervical."
      },
      {
        "q": "Como posso tirar dúvidas com os professores?",
        "a": "Você poderá deixar suas dúvidas em nossa plataforma de ensino. As suas perguntas serão respondidas por nossos professores!"
      },
      {
        "q": "Como será a entrega do certificado?",
        "a": "O certificado será entregue após você realizar todas às aulas da Certificação. Você poderá retirá-lo dentro da nossa plataforma de ensino."
      },
      {
        "q": "O conteúdo da Certificação é o mesmo que estão nos cursos da Star?",
        "a": "Não, o conteúdo da Certificação é exclusivo e com uma visão aprofundada para transformar o fisioterapeuta em \"expert\" na temática. São 60h de conteúdos dedicados ao aprofundamento em Coluna Cervical, distribuídas em 5 módulos."
      },
      {
        "q": "Sou estudante, posso fazer a Certificação?",
        "a": "Você pode fazer a Certificação. No entanto, ela é indicada para fisioterapeutas que têm uma demanda de dor cervical no consultório. © 2024 Fisio em Ortopedia. Todos os direitos reservados."
      }
    ],
    "heroBg": "/__l5e/assets-v1/1402b17b-b63b-41ad-9284-c0be00e5e8bb/quadril-background.webp",
    "comoFuncionaNaSecaoBranca": true,
    "benefitsGrid": [
      {
        "icon": "stethoscope",
        "title": "CONQUISTE SEGURANÇA PARA FAZER UMA AVALIAÇÃO COMPLETA DA COLUNA CERVICAL"
      },
      {
        "icon": "book-open",
        "title": "MELHORE SEU REPERTÓRIO COM TÉCNICAS BASEADAS EM EVIDÊNCIAS"
      },
      {
        "icon": "award",
        "title": "TORNE-SE REFERÊNCIA NO TRATAMENTO DAS PATOLOGIAS DA COLUNA CERVICAL"
      },
      {
        "icon": "heart-pulse",
        "title": "ATENDA COM EFICÁCIA SEUS PACIENTES E OFEREÇA UM TRATAMENTO COMPLETO"
      }
    ]
  },
  "eletro": {
    "slug": "eletro",
    "logo": "/__l5e/assets-v1/555e6ba9-d3fb-4e18-9341-59551b11e5e3/cert-eletro-logo.webp",
    "heroTitle": [
      "Como utilizar os Agentes Eletrofísicos na sua sessão!"
    ],
    "heroSub": [
      "Um curso 100% online, com 60h, repleto de",
      "casos clínicos reais e aulas práticas"
    ],
    "ctaHero": "MATRICULE-SE AGORA",
    "cards": [
      {
        "img": "/__l5e/assets-v1/fe5a4166-9ef8-41c7-b299-603b460ae442/cert-2cdb95df18.webp",
        "lines": [
          "Aprofunde seu raciocínio",
          "em conceitos gerais sobre os Agentes Eletrofísicos"
        ]
      },
      {
        "img": "/__l5e/assets-v1/abc9db93-26af-4c75-aba4-65b35aceedbf/cert-6307cb4d74.webp",
        "lines": [
          "Aprenda com profissionais altamente capacitados e experientes no tema"
        ]
      },
      {
        "img": "/__l5e/assets-v1/a04cfbdc-12ba-43d4-a70e-bd59aaef6312/cert-0cf6cef76c.webp",
        "lines": [
          "Veja exemplos práticos",
          "e vídeos de como utilizar os Agentes corretamente"
        ]
      },
      {
        "img": "/__l5e/assets-v1/23b03aa9-bcb3-4b74-a763-cda6a85e00f5/cert-f233ecc82a.webp",
        "lines": [
          "Entenda os parâmetros ideais para diferentes condições clínicas",
          "Um passo a passo de como utilizar agentes eletrofícos no seu consultório."
        ]
      }
    ],
    "passoTitle": null,
    "stats": [
      {
        "valor": "05",
        "label": "Módulos"
      },
      {
        "valor": "60H",
        "label": "Conteúdos"
      },
      {
        "valor": "80%",
        "label": "Conteúdo Prático"
      }
    ],
    "destaque": [
      "Domine parâmetros",
      "comprovados",
      "cientificamente"
    ],
    "ctaMid": "TENHO INTERESSE",
    "mockupSmartphone": "/__l5e/assets-v1/ef28d9b8-1d0c-4a68-aa49-d5213563fe44/cert-1cace4fc99.webp",
    "expertTitle": null,
    "benefits": [
      {
        "icon": "/__l5e/assets-v1/6c10ea61-93a1-42da-b301-ebd6dd2f223f/cert-bd2198facc.webp",
        "iconAlt": "Escudo.png",
        "lines": [
          "Conquiste segurança",
          "para utilizar os Agentes Eletrofísicos"
        ]
      },
      {
        "icon": "/__l5e/assets-v1/6a07b1f0-be5c-4ffc-802d-820691898dc2/cert-1be094f95e.webp",
        "iconAlt": "Livro.png",
        "lines": [
          "Melhore seu repertório",
          "de práticas baseadas",
          "em evidências"
        ]
      },
      {
        "icon": "/__l5e/assets-v1/bf42a964-e035-40c6-bbf3-60b06ee97c6a/cert-94e5f44572.webp",
        "iconAlt": "Prancheta.png",
        "lines": [
          "Atenda com eficácia seus pacientes e ofereça um tratamento completo"
        ]
      }
    ],
    "fundo": "/__l5e/assets-v1/1f798a10-1505-425f-b3f2-9b9c7ce2ff1f/cert-47b9d648e2.webp",
    "comoFuncionaTitle": [
      "Como funciona",
      "a Certificação?"
    ],
    "comoFuncionaText": "É um curso 100% online, com aulas gravadas, onde ensinaremos o que há de mais moderno sobre os Agentes Eletrofísicos. Um treinamento recheado de aplicações clínicas e aulas práticas.",
    "comoFuncionaImg": "/__l5e/assets-v1/289a8572-bcc5-44f9-b3e2-b16e0855a6cb/cert-abbf52ff62.webp",
    "aprenderTitle": [
      "O que você vai",
      "aprender?"
    ],
    "modulos": [
      {
        "titulo": "Módulo 1: Fotobiomodulação",
        "itens": [
          "Conceitos Gerais",
          "Parâmetros e Dosimetria",
          "Aplicabilidade para diferentes objetivos",
          "Comprando um aparelho",
          "Contraindicações",
          "Casos Clínicos"
        ]
      },
      {
        "titulo": "Módulo 2: Correntes Elétricas (EENM)",
        "itens": [
          "Conceitos Gerais",
          "Tipos de EENM",
          "Parâmetros e dosimetria",
          "Explorando o equipamento",
          "Contraindicações",
          "Casos Clínicos"
        ]
      },
      {
        "titulo": "Módulo 3: Ultrassom Terapêutico",
        "itens": [
          "Conceitos Gerais",
          "Aplicações Clínicas",
          "Dosimetria",
          "Sonoforese",
          "Contraindicações",
          "Casos Clínicos"
        ]
      },
      {
        "titulo": "Módulo 4: Terapia Combinada",
        "itens": [
          "Conceitos Gerais",
          "Quando utilizar?",
          "Como utilizar?",
          "Aplicações Clínicas",
          "Contraindicações",
          "Casos Clínicos"
        ]
      },
      {
        "titulo": "Módulo 5: Correntes Elétricas (Analgesia)",
        "itens": [
          "Conhecimentos básicos sobre dor",
          "Princípios gerais do TENS",
          "Parâmetros de estimulação",
          "Aplicabilidade e raciocínio clínico",
          "Contraindicações",
          "Casos Clínicos"
        ]
      }
    ],
    "pilares": [],
    "ctaPilares": null,
    "depoimentos": [
      {
        "quote": "Em cada conteúdo, em cada discussão a gente sempre sai com a cabeça fervendo e querendo mais! Aqui, a gente quebra conceitos o tempo todo e isso nos faz crescer profissionalmente e pessoalmente.",
        "foto": "/__l5e/assets-v1/381fdc50-95dd-4ecb-9c29-9de3cac693ed/cert-2213f59102.webp",
        "nome": "Cindy Balansin",
        "role": "Fisioterapeuta"
      },
      {
        "quote": "Conteúdo baseado em evidências e professores sempre solícitos para sanar as dúvidas, além de ótimas estratégias de fixação do conteúdo!",
        "foto": "/__l5e/assets-v1/8e0a69df-f9c1-4347-a1ea-cb0d309ba82f/cert-ed35df084e.webp",
        "nome": "João Fornaza",
        "role": "Fisioterapeuta"
      }
    ],
    "seloAutoridade": "/__l5e/assets-v1/9c7e500e-c1cd-46dc-a91a-cee3fbd1a113/cert-628dc121a3.webp",
    "autoridadeTitle": "Aprenda com quem domina o assunto",
    "autoridadeSub": "Descubra como os fisioterapeutas que você mais admira estão fazendo para que você se torne especialista este ano",
    "ofertaTitle": "Ofereça o melhor tratamento para os seus pacientes",
    "professores": [
      {
        "foto": "/__l5e/assets-v1/9401bad1-5362-4363-bf89-481c712ba1c0/cert-7ea4884289.webp",
        "nome": "Carlos Eduardo Pinfildi",
        "role": "Fisioterapeuta",
        "bio": [
          "Professor Associado da Unifesp, Santos",
          "Mestre",
          "Ciências Saúde - Unifesp",
          "Doutor",
          "Ciências Saúde, Unifesp Pós-Doutorado na Griffith University - Austrália",
          "Aperfeiçoamento em Ciências da Saúde, Cirurgia Plástica",
          "Especialização em Fisioterapia Ortopédica e Esportiva, Instituto Cohen"
        ]
      },
      {
        "foto": "/__l5e/assets-v1/ec2744b4-b180-482f-a16e-233261f3f0a5/cert-25a4ecab8b.webp",
        "nome": "Júlio Fernandes",
        "role": "Fisioterapeuta",
        "bio": [
          "Especialização em Fisioterapia Músculo-Esquelética - ISCM-SP.",
          "Mestre",
          "Ciência Cirúrgica Interdisciplinar - UNIFESP/EPM.",
          "Doutor",
          "Ciências do Movimento Humano e Reabilitação - UNIFESP.",
          "Especialização em Fisioterapia Esportiva. -  SONAFE, Brasil",
          "Aperfeiçoamento em Fisioterapia Músculo-Esquelética - ISCM-SP."
        ]
      },
      {
        "foto": "/__l5e/assets-v1/ef8d466e-4ece-4344-8529-f92b68f91c11/cert-97801f5016.webp",
        "nome": "Josimari DeSantana",
        "role": "Fisioterapeuta",
        "bio": [
          "Professora da Universidade Federal de Sergipe",
          "Mestre e Doutora",
          "Ciências da Reabilitação pela USP (FMRP-USP)",
          "Pós Doc",
          "Department of Physical Therapy and Rehabilitation Science, University of Iowa (EUA, 2007-08).",
          "Especialização em Dor pela Sociedade Brasileira para o Estudo da Dor (SBED/ 2005)"
        ]
      }
    ],
    "mockupTablet": "/__l5e/assets-v1/37f9e267-401e-425b-bf7a-3cfdfc6a3841/cert-91c0dd4185.webp",
    "selo2anos": "/__l5e/assets-v1/d26b5cc0-ffb6-4451-bd5f-fd70768b7153/cert-2490e6adce.webp",
    "preco": [
      "DE R$697 POR",
      "R$ 397",
      "ou 12x R$41,06"
    ],
    "promo": [],
    "checkoutLabel": "MATRICULE-SE",
    "checkoutUrl": "https://chk.eduzz.com/VWGZ1J2P07?cupom=300OFF&df=1&pf=1",
    "bonus": [
      "BÔNUS: Ao se matricular você garante R$500,00 de desconto em todas as outras Certificações da FEO.",
      "Desconto aplicado direto no carrinho. Não perca essa chance de mudar sua carreira!"
    ],
    "faqSupport": [
      "Ainda precisa de ajuda? Entre em",
      "contato com o suporte ao cliente!"
    ],
    "suporteLabel": "CONTATE-NOS",
    "suporteUrl": "https://api.whatsapp.com/send?1=pt_BR&phone=5511930316779",
    "faqImg": "/__l5e/assets-v1/92567dc4-97ff-48d2-b5dc-5c3a18f92f72/cert-871f9f89a1.webp",
    "faq": [
      {
        "q": "Por quanto tempo terei acesso à certificação?",
        "a": "O conteúdo completo da Certificação ficará disponível por dois anos contados a partir do momento da sua inscrição."
      },
      {
        "q": "A certificação é somente para fisioterapeutas?",
        "a": "Sim, a certificação foi pensada para fisioterapeutas que já atuam na área."
      },
      {
        "q": "Como posso tirar dúvidas com os professores?",
        "a": "Você poderá deixar suas dúvidas em nossa plataforma de ensino. As suas perguntas serão respondidas por nossos professores!"
      },
      {
        "q": "Como será a entrega do certificado?",
        "a": "O certificado será entregue após você realizar todas às aulas da Certificação. Você poderá retirá-lo dentro da nossa plataforma de ensino."
      },
      {
        "q": "O conteúdo da Certificação é o mesmo que estão nos cursos da Star?",
        "a": "Não, o conteúdo da Certificação é exclusivo e com uma visão aprofundada para transformar o fisioterapeuta em \"expert\" na temática. São 60h de conteúdos dedicados ao aprofundamento em Agentes Eletrofísicos, distribuídas em 5 módulos."
      },
      {
        "q": "Sou estudante, posso fazer a Certificação?",
        "a": "Você pode fazer a Certificação. No entanto, ela é indicada para fisioterapeutas formados. © 2025 Fisio em Ortopedia. Todos os direitos reservados."
      }
    ],
    "heroBg": "/__l5e/assets-v1/1402b17b-b63b-41ad-9284-c0be00e5e8bb/quadril-background.webp",
    "comoFuncionaNaSecaoBranca": true,
    "benefitsGrid": [
      {
        "icon": "stethoscope",
        "title": "CONQUISTE SEGURANÇA PARA ESCOLHER E DOSAR OS AGENTES ELETROFÍSICOS"
      },
      {
        "icon": "book-open",
        "title": "MELHORE SEU REPERTÓRIO COM TÉCNICAS BASEADAS EM EVIDÊNCIAS"
      },
      {
        "icon": "award",
        "title": "TORNE-SE REFERÊNCIA NO USO CLÍNICO DOS AGENTES ELETROFÍSICOS"
      },
      {
        "icon": "heart-pulse",
        "title": "ATENDA COM EFICÁCIA SEUS PACIENTES E OFEREÇA UM TRATAMENTO COMPLETO"
      }
    ]
  },
  "ombro": {
    "slug": "ombro",
    "logo": "/__l5e/assets-v1/1892580e-0479-4542-8ecf-8b09347eae23/cert-ombro-logo.webp",
    "heroTitle": [
      "Domine todas as etapas de Avaliação e Tratamento do Ombro"
    ],
    "heroSub": [
      "Um curso 100% online, com 60h, repleto de",
      "casos clínicos reais e aulas práticas"
    ],
    "ctaHero": "MATRICULE-SE AGORA",
    "cards": [
      {
        "img": "/__l5e/assets-v1/5c9546b5-c380-4194-9e93-1b2ed5e75597/cert-72a85c73fb.webp",
        "lines": [
          "Aprofunde seu raciocínio clínico com o que há de mais novo na ciência sobre ombro"
        ]
      },
      {
        "img": "/__l5e/assets-v1/dcbf84ae-158a-40da-b538-e4e8fb1f020e/cert-252e76c817.webp",
        "lines": [
          "Aprenda com profissionais referências na Reabilitação do Complexo do Ombro"
        ]
      },
      {
        "img": "/__l5e/assets-v1/4bd3d967-8101-4776-b8a0-b955583d1579/cert-a07fe6f94d.webp",
        "lines": [
          "Veja exemplos práticos e vídeos de como atender seus pacientes"
        ]
      },
      {
        "img": "/__l5e/assets-v1/2a3d9c69-6848-4462-8614-8b920114a2b7/cert-139b714d1a.webp",
        "lines": [
          "Saiba como tratar as principais patologias do Complexo do Ombro",
          "Um passo a passo para você atender desde os casos mais comuns até os mais complexos"
        ]
      }
    ],
    "passoTitle": null,
    "stats": [
      {
        "valor": "05",
        "label": "Módulos"
      },
      {
        "valor": "60H",
        "label": "Conteúdos"
      },
      {
        "valor": "80%",
        "label": "Conteúdo Prático"
      }
    ],
    "destaque": [
      "Domine técnicas",
      "comprovadas",
      "cientificamente"
    ],
    "ctaMid": "TENHO INTERESSE",
    "mockupSmartphone": "/__l5e/assets-v1/43d9da93-f456-4528-a06b-997caf3ed089/cert-0690afb4f1.webp",
    "expertTitle": null,
    "benefits": [
      {
        "icon": "/__l5e/assets-v1/6c10ea61-93a1-42da-b301-ebd6dd2f223f/cert-bd2198facc.webp",
        "iconAlt": "Escudo.png",
        "lines": [
          "Conquiste segurança",
          "para avaliar e tratar seus pacientes"
        ]
      },
      {
        "icon": "/__l5e/assets-v1/6a07b1f0-be5c-4ffc-802d-820691898dc2/cert-1be094f95e.webp",
        "iconAlt": "Livro.png",
        "lines": [
          "Melhore seu repertório",
          "de práticas baseadas",
          "em evidências"
        ]
      },
      {
        "icon": "/__l5e/assets-v1/bf42a964-e035-40c6-bbf3-60b06ee97c6a/cert-94e5f44572.webp",
        "iconAlt": "Prancheta.png",
        "lines": [
          "Atenda com eficácia qualquer caso clínico do Complexo do Ombro"
        ]
      }
    ],
    "fundo": "/__l5e/assets-v1/4ccf503f-b174-40cc-8921-68695238ce96/cert-5b3050168a.webp",
    "comoFuncionaTitle": [
      "Como funciona",
      "a Certificação?"
    ],
    "comoFuncionaText": "É um curso 100% online, com aulas gravadas, onde ensinaremos o que há de mais moderno na avaliação e tratamento do ombro. Um curso repleto de aplicações clínicas e aulas práticas.",
    "comoFuncionaImg": "/__l5e/assets-v1/87bb3680-8533-49ce-8625-96175e6b318f/cert-9266e1df0f.webp",
    "aprenderTitle": [
      "O que você vai",
      "aprender?"
    ],
    "modulos": [
      {
        "titulo": "Módulo 1: Introdução e Fundamentos",
        "itens": [
          "Princípios do tratamento",
          "Tomada de decisão e abordagem integrada",
          "Lesões traumáticas X atraumáticas."
        ]
      },
      {
        "titulo": "Módulo 2: Avaliação do Complexo do Ombro",
        "itens": [
          "Anatomia Funcional",
          "Avaliação Cinético-Funcional do ombro",
          "Avaliação da Dor baseada em mecanismos",
          "Avaliação de Exames de Imagem",
          "Ferramentas e Métodos de avaliação funcional"
        ]
      },
      {
        "titulo": "Módulo 3: Intervenções, Progressão e Alta",
        "itens": [
          "Exposição Gradual",
          "Prescrição de Exercícios",
          "Progressão de Carga e atividades funcionais",
          "Exercícios Domiciliares",
          "Terapia Manual"
        ]
      },
      {
        "titulo": "Módulo 4: Principais Condições Clínicas",
        "itens": [
          "Manguito Rotador e demais tendões",
          "Tendinite Calcária",
          "Capsulite Adesiva",
          "Artrose",
          "Luxações e Instabilidade"
        ]
      },
      {
        "titulo": "Módulo 5: Abordagens Pós-trauma e Pós-cirúrgicas",
        "itens": [
          "P.O. de Manguito Rotador",
          "Fraturas de terço proximal",
          "Fraturas e Instabilidade Clavicular",
          "Prótese de Úmero",
          "P.O. de Instabilidade"
        ]
      }
    ],
    "pilares": [],
    "ctaPilares": null,
    "depoimentos": [
      {
        "quote": "Em cada conteúdo, em cada discussão a gente sempre sai com a cabeça fervendo e querendo mais! Aqui, a gente quebra conceitos o tempo todo e isso nos faz crescer profissionalmente e pessoalmente.",
        "foto": "/__l5e/assets-v1/381fdc50-95dd-4ecb-9c29-9de3cac693ed/cert-2213f59102.webp",
        "nome": "Cindy Balansin",
        "role": "Fisioterapeuta"
      },
      {
        "quote": "Conteúdo baseado em evidências e professores sempre solícitos para sanar as dúvidas, além de ótimas estratégias de fixação do conteúdo!",
        "foto": "/__l5e/assets-v1/8e0a69df-f9c1-4347-a1ea-cb0d309ba82f/cert-ed35df084e.webp",
        "nome": "João Fornaza",
        "role": "Fisioterapeuta"
      }
    ],
    "seloAutoridade": "/__l5e/assets-v1/d9cf8934-e91c-4638-b124-775a52e7a722/cert-dc5a1e6161.webp",
    "autoridadeTitle": "Aprenda com quem domina o assunto",
    "autoridadeSub": "Descubra como os fisioterapeutas que você mais admira estão fazendo para que você se torne especialista este ano",
    "professores": [
      {
        "foto": "/__l5e/assets-v1/95ed388d-5cd4-4a80-b155-50d40b10f284/cert-85eab85bad.webp",
        "nome": "Anamaria Siriani",
        "role": "Fisioterapeuta",
        "bio": [
          "Docente da Faculdade de Medicina de Ribeirão Preto da Universidade de São Paulo (FMRP-USP)",
          "Doutura",
          "Eletromiografia de Superfície pela Universidade Estadual de Campinas",
          "Pós DOC",
          "Department of Rehabilitation Medicine da University of Washington, Seattle, EUA",
          "Coordenadora do Ambulatório de Reabilitação do Complexo do Ombro (A.R.C.O.)"
        ]
      },
      {
        "foto": "/__l5e/assets-v1/c7894c3a-6bfe-4938-8ec9-a5410067a69f/cert-26a3db03d7.webp",
        "nome": "Germana Barbosa",
        "role": "Fisioterapeuta",
        "bio": [
          "Especialista em Fisioterapia Esportiva e Traumato-Ortopedia pelo COFFITO.",
          "Mestre",
          "Reabilitação Musculoesquelética pela Universidade Federal do Rio Grande do Norte (UFRN 2016)",
          "Doutora",
          "Plasticidade muscular e suas implicações para a fisioterapia e a reabilitação pela UFSCar (2019)",
          "Docente da Universidade Federal do Rio Grande do Norte (UFRN)"
        ]
      },
      {
        "foto": "/__l5e/assets-v1/80441ffc-c1ee-47c9-91da-02c16dbc74b9/cert-68b9158745.webp",
        "nome": "Giseli Harumi",
        "role": "Fisioterapeuta",
        "bio": [
          "Docente e supervisora de estágio em saúde coletiva e fisioterapia aquática no Centro Universitário Educacional de Guaxupé (UNIFEG).",
          "Mestre e Doutora",
          "Programa de Pós Graduação Reabilitação e Desempenho Funcional da Universidade de São Paulo - Faculdade de Medicina de Ribeirão Preto (USP-FMRP)",
          "Pós DOC",
          "Pós-Doutora pela Comissão de Pesquisa e Ensino da Faculdade de Medicina de Ribeirão Preto (USP-FMRP)",
          "Aperfeiçoamento em Saúde Baseada em Evidências pelo Instituto Sírio Libanês de Ensino e Pesquisa"
        ]
      },
      {
        "foto": "/__l5e/assets-v1/89fddc41-bc79-408a-afdc-e637b06df8f4/cert-4d4c136f80.webp",
        "nome": "Luiz Scola",
        "role": "Fisioterapeuta",
        "bio": [
          "Especialista em fisioterapia musculoesquelética pela ISCMSP;",
          "Mestre e Doutor",
          "Fisioterapia pela Universidade Cidade de São Paulo, UNICID;",
          "Empreendedor",
          "Sócio proprietário da clínica de fisioterapia CineticsPhysio (Campinas-SP)",
          "Membro da Sociedade Nacional de Fisioterapia Esportiva (SONAFE)",
          "Docente e Supervisor de Estágio de Ortopedia da Universidade Paulista (UNIP);",
          "Ofereça o melhor tratamento para os seus pacientes"
        ]
      }
    ],
    "mockupTablet": "/__l5e/assets-v1/5639830f-d148-4d70-80d9-d28fd2956201/cert-1d141a87c8.webp",
    "selo2anos": "/__l5e/assets-v1/ef0c67ea-15c6-4f40-9d39-26ecc1f38ed2/cert-e5879263d5.webp",
    "preco": [
      "DE R$697 POR",
      "10x R$24,70",
      "ou R$247,00 à vista"
    ],
    "promo": [
      "Aproveite o valor promocional!",
      "ÚLTIMOS DIAS - R$450,00 OFF"
    ],
    "checkoutLabel": "MATRICULE-SE",
    "checkoutUrl": "https://chk.eduzz.com/D0RAA28B9Y?cupom=PROMO&df=1&np=10",
    "bonus": [
      "BÔNUS: Ao se matricular você garante R$600,00 de desconto em todas as outras Certificações da FEO.",
      "Desconto aplicado direto no carrinho. Não perca essa chance de mudar sua carreira!"
    ],
    "faqSupport": [
      "Ainda precisa de ajuda? Entre em",
      "contato com o suporte ao cliente!"
    ],
    "suporteLabel": "FALE CONOSCO",
    "suporteUrl": "https://api.whatsapp.com/send?1=pt_BR&phone=5511930316779",
    "faqImg": "/__l5e/assets-v1/92567dc4-97ff-48d2-b5dc-5c3a18f92f72/cert-871f9f89a1.webp",
    "faq": [
      {
        "q": "Por quanto tempo terei acesso à certificação?",
        "a": "O conteúdo completo da Certificação ficará disponível por dois anos contados a partir do momento da sua inscrição."
      },
      {
        "q": "A certificação é somente para fisioterapeutas?",
        "a": "Sim, a certificação foi pensada para fisioterapeutas que já atuam na área e trabalham com pacientes com dor cervical."
      },
      {
        "q": "Como posso tirar dúvidas com os professores?",
        "a": "Você poderá deixar suas dúvidas em nossa plataforma de ensino. As suas perguntas serão respondidas por nossos professores!"
      },
      {
        "q": "Como será a entrega do certificado?",
        "a": "O certificado será entregue após você realizar todas às aulas da Certificação. Você poderá retirá-lo dentro da nossa plataforma de ensino."
      },
      {
        "q": "O conteúdo da Certificação é o mesmo que estão nos cursos da Star?",
        "a": "Não, o conteúdo da Certificação é exclusivo e com uma visão aprofundada para transformar o fisioterapeuta em \"expert\" na temática. São 60h de conteúdos dedicados ao aprofundamento e distribuídos em 5 módulos."
      },
      {
        "q": "Sou estudante, posso fazer a Certificação?",
        "a": "Você pode fazer a Certificação. No entanto, ela é indicada para fisioterapeutas que têm uma demanda no consultório. © 2026 Fisio em Ortopedia. Todos os direitos reservados."
      }
    ],
    "ofertaTitle": "Ofereça o melhor tratamento para os seus pacientes",
    "heroBg": "/__l5e/assets-v1/1402b17b-b63b-41ad-9284-c0be00e5e8bb/quadril-background.webp",
    "comoFuncionaNaSecaoBranca": true,
    "benefitsGrid": [
      {
        "icon": "stethoscope",
        "title": "CONQUISTE SEGURANÇA PARA FAZER UMA AVALIAÇÃO COMPLETA DO OMBRO"
      },
      {
        "icon": "book-open",
        "title": "MELHORE SEU REPERTÓRIO COM TÉCNICAS BASEADAS EM EVIDÊNCIAS"
      },
      {
        "icon": "award",
        "title": "TORNE-SE REFERÊNCIA NO TRATAMENTO DAS PATOLOGIAS DO OMBRO"
      },
      {
        "icon": "heart-pulse",
        "title": "ATENDA COM EFICÁCIA SEUS PACIENTES E OFEREÇA UM TRATAMENTO COMPLETO"
      }
    ]
  },
  "tornozelo": {
    "slug": "tornozelo",
    "logo": "/__l5e/assets-v1/079ccb7f-6589-4304-9e52-5dacb4c4fcfd/cert-tornozelo-logo.webp",
    "heroTitle": [
      "Domine do início ao fim a Avaliação e Tratamento do Tornozelo e Pé"
    ],
    "heroSub": [
      "Um curso 100% online, com 60h, repleto de",
      "casos clínicos reais e aulas práticas"
    ],
    "ctaHero": "MATRICULE-SE AGORA",
    "cards": [
      {
        "img": "/__l5e/assets-v1/7411e45a-f372-4ec5-a74d-05701e4e003a/cert-08da7d1d01.webp",
        "lines": [
          "Aprofunde seu raciocínio em conceitos gerais sobre tornozelo e pé"
        ]
      },
      {
        "img": "/__l5e/assets-v1/8d7c284b-85b7-4c61-b635-8da86d2dcc88/cert-20f804df2a.webp",
        "lines": [
          "Aprenda com profissionais altamente capacitados e experientes no tema"
        ]
      },
      {
        "img": "/__l5e/assets-v1/a5c66607-9d3b-4e2d-b437-9414851c186d/cert-9e2d57d746.webp",
        "lines": [
          "Veja como aplicar avaliação, testes funcionais e intervenções manuais no dia a dia"
        ]
      },
      {
        "img": "/__l5e/assets-v1/baa67aa7-d269-421b-a162-7a3fb9b5d26d/cert-5af84d054f.webp",
        "lines": [
          "Entenda como dominar do exame clínico às estratégias de reabilitação funcional",
          "Um passo a passo de como transformar seu raciocínio clínico em reabilitação eficaz do tornozelo e pé"
        ]
      }
    ],
    "passoTitle": null,
    "stats": [
      {
        "valor": "06",
        "label": "Módulos"
      },
      {
        "valor": "60H",
        "label": "Conteúdos"
      },
      {
        "valor": "80%",
        "label": "Conteúdo Prático"
      }
    ],
    "destaque": [
      "Domine técnicas",
      "comprovadas",
      "cientificamente"
    ],
    "ctaMid": "TENHO INTERESSE",
    "mockupSmartphone": "/__l5e/assets-v1/4fdb75cb-8576-4e3e-b7ed-0d27fdee1139/cert-37df288ada.webp",
    "expertTitle": null,
    "benefits": [
      {
        "icon": "/__l5e/assets-v1/6c10ea61-93a1-42da-b301-ebd6dd2f223f/cert-bd2198facc.webp",
        "iconAlt": "Escudo.png",
        "lines": [
          "Conquiste segurança",
          "para realizar uma avaliação clínica do tornozelo e do pé"
        ]
      },
      {
        "icon": "/__l5e/assets-v1/6a07b1f0-be5c-4ffc-802d-820691898dc2/cert-1be094f95e.webp",
        "iconAlt": "Livro.png",
        "lines": [
          "Melhore seu repertório",
          "com práticas baseadas",
          "em evidências"
        ]
      },
      {
        "icon": "/__l5e/assets-v1/26218089-9afc-41aa-9e4a-ab6ec516284e/cert-94e5f44572.webp",
        "iconAlt": "Prancheta.png",
        "lines": [
          "Atenda com eficácia seus pacientes e ofereça um tratamento completo"
        ]
      }
    ],
    "fundo": "/__l5e/assets-v1/a1710fc3-9c7a-46fe-a6a5-0cfd9d0d8142/cert-469a8a69d8.webp",
    "comoFuncionaTitle": [
      "Como funciona",
      "a Certificação?"
    ],
    "comoFuncionaText": "É um curso 100% online, com aulas gravadas, em que ensinaremos o que há de mais novo sobre o diagnóstico clínico e as intervenções para o tornozelo e pé. Um treinamento recheado de aplicações clínicas e aulas práticas.",
    "comoFuncionaImg": null,
    "aprenderTitle": [
      "O que você vai",
      "aprender?"
    ],
    "modulos": [
      {
        "titulo": "Módulo 1 - Introdução e Avaliação do Tornozelo e Pé",
        "itens": []
      },
      {
        "titulo": "Módulo 2 - Intervenções, Progressão e Critérios de Alta",
        "itens": []
      },
      {
        "titulo": "Módulo 3 - Calçados e Órteses",
        "itens": []
      },
      {
        "titulo": "Módulo 4 - Condições Complexas e Dolorosas do Pé e Tornozelo",
        "itens": []
      }
    ],
    "pilares": [],
    "ctaPilares": null,
    "depoimentos": [
      {
        "quote": "Conteúdo baseado em evidências e professores sempre solícitos para sanar as dúvidas, além de ótimas estratégias de fixação do conteúdo!",
        "foto": null,
        "nome": "Cindy Balansin",
        "role": "Fisioterapeuta"
      }
    ],
    "seloAutoridade": "/__l5e/assets-v1/4000ee2c-7d42-40c4-b39a-a8f6b3bf1651/cert-73fa0432f3.webp",
    "autoridadeTitle": "Aprenda com quem domina o assunto",
    "autoridadeSub": "Descubra como os fisioterapeutas que você mais admira estão fazendo para que você se torne especialista este ano",
    "ofertaTitle": "Ofereça o melhor tratamento para os seus pacientes",
    "professores": [
      {
        "foto": "/__l5e/assets-v1/265abbaf-d5e0-4d62-89e9-5fe746c33c9c/cert-21c3df965a.webp",
        "nome": "Aline Souza",
        "role": "Fisioterapeuta",
        "bio": [
          "Fisioterapeuta e Coordenadora Técnica da Rede de Clínicas Club Fisio",
          "Especialista",
          "Especialista em Fisioterapia Músculo-esquelética da Santa Casa de Misericórdia de São Paulo",
          "Aprimoramento em Tornozelo/Pé; Amputados e Linfedema pela Santa Casa de Misericórdia de São Paulo",
          "Mestre",
          "Ciências da Saúde pela Faculdade de Ciências Médicas da Santa Casa de São Paulo (FCMSCSP)",
          "Docente da Pós-Graduação de Fisioterapia em Traumatologia do Portal Fisio em Ortopedia"
        ]
      },
      {
        "foto": "/__l5e/assets-v1/ba3d098a-940f-4df3-844b-0823fa4828e4/cert-210d9c018c.webp",
        "nome": "André Mendes",
        "role": "Fisioterapeuta",
        "bio": [
          "Especialização em Ortopedia e Traumatologia",
          "Mestre",
          "Mestrado em Fisioterapia pela Universidade Cidade de São Paulo - UNICID",
          "Doutorando",
          "Doutorando em Fisioterapia pela Universidade Cidade de São Paulo - UNICID. Sendo as principais áreas de atuação: palmilhas, patologias do pé, disfunções de marcha",
          "Fisioterapeuta pela Faculdade do Clube Náutico Mogiano"
        ]
      },
      {
        "foto": "/__l5e/assets-v1/625e23b0-f975-4507-bb23-0f5ef7ce9e3b/cert-1d077116e1.webp",
        "nome": "Carolina Lins",
        "role": "Fisioterapeuta",
        "bio": [
          "Fisioterapeuta e Pesquisadora voluntária do Grupo de Pé e Tornozelo do Hospital de Clínicas da UNICAMP",
          "Mestre e Doutora",
          "Mestre e Doutora em Ciências pelo Departamento de Ortopedia, Reumatologia e Traumatologia da Faculdade de Ciências Médicas",
          "Empreendedora",
          "Proprietária da clínica de fisioterapia Carolina Lins, Ciência e Fisioterapia Avançada",
          "Diretora do Site UNICAMP-IOU do curso PPCR, Principles and Practice of Clinical Research, Universidade de Harvard"
        ]
      }
    ],
    "mockupTablet": "/__l5e/assets-v1/1f79401e-7ea5-4411-91a3-246b4da3b334/cert-c4712b70e3.webp",
    "selo2anos": "/__l5e/assets-v1/0ac25c24-3bc5-47b9-892e-650165c7a709/cert-516f51a60e.webp",
    "preco": [
      "DE R$697 POR",
      "R$ 397",
      "ou 12x R$41,06"
    ],
    "promo": [],
    "checkoutLabel": "MATRICULE-SE",
    "checkoutUrl": "https://chk.eduzz.com/69KAZ55A0O?cupom=300OFF&df=1&pf=1",
    "bonus": [
      "BÔNUS: Ao se matricular você garante R$500,00 de desconto em todas as outras Certificações da FEO.",
      "Desconto aplicado direto no carrinho. Não perca essa chance de mudar sua carreira!"
    ],
    "faqSupport": [
      "Ainda precisa de ajuda? Entre em",
      "contato com o suporte ao cliente!"
    ],
    "suporteLabel": "FALE CONOSCO",
    "suporteUrl": "https://api.whatsapp.com/send?1=pt_BR&phone=5511930316779",
    "faqImg": "/__l5e/assets-v1/92567dc4-97ff-48d2-b5dc-5c3a18f92f72/cert-871f9f89a1.webp",
    "faq": [
      {
        "q": "Por quanto tempo terei acesso à certificação?",
        "a": "O conteúdo completo da Certificação ficará disponível por dois anos contados a partir do momento da sua inscrição."
      },
      {
        "q": "A certificação é somente para fisioterapeutas?",
        "a": "Sim, a certificação foi pensada para fisioterapeutas que já atuam na área e trabalham com pacientes que lidam com condições clínicas relacionadas ao tornozelo e ao pé."
      },
      {
        "q": "Como posso tirar dúvidas com os professores?",
        "a": "Você poderá deixar suas dúvidas em nossa plataforma de ensino. As suas perguntas serão respondidas por nossos professores!"
      },
      {
        "q": "Como será a entrega do certificado?",
        "a": "O certificado será entregue após você realizar todas às aulas da Certificação. Você poderá retirá-lo dentro da nossa plataforma de ensino."
      },
      {
        "q": "O conteúdo da Certificação é o mesmo que estão nos cursos da Star?",
        "a": "Não, o conteúdo da Certificação é exclusivo e com uma visão aprofundada para transformar o fisioterapeuta em \"expert\" na temática. São 60h de conteúdos dedicados ao aprofundamento e distribuídos em 5 módulos."
      },
      {
        "q": "Sou estudante, posso fazer a Certificação?",
        "a": "Você pode fazer a Certificação. No entanto, ela é indicada para fisioterapeutas que têm uma demanda no consultório. © 2025 Fisio em Ortopedia. Todos os direitos reservados."
      }
    ],
    "heroBg": "/__l5e/assets-v1/1402b17b-b63b-41ad-9284-c0be00e5e8bb/quadril-background.webp",
    "comoFuncionaNaSecaoBranca": true,
    "benefitsGrid": [
      {
        "icon": "stethoscope",
        "title": "CONQUISTE SEGURANÇA PARA FAZER UMA AVALIAÇÃO COMPLETA DO TORNOZELO E PÉ"
      },
      {
        "icon": "book-open",
        "title": "MELHORE SEU REPERTÓRIO COM TÉCNICAS BASEADAS EM EVIDÊNCIAS"
      },
      {
        "icon": "award",
        "title": "TORNE-SE REFERÊNCIA NO TRATAMENTO DAS PATOLOGIAS DO TORNOZELO E PÉ"
      },
      {
        "icon": "heart-pulse",
        "title": "ATENDA COM EFICÁCIA SEUS PACIENTES E OFEREÇA UM TRATAMENTO COMPLETO"
      }
    ]
  },
  "joelho": {
    "slug": "joelho",
    "logo": "/__l5e/assets-v1/5e10d86a-e0e9-4f7e-904a-1fe1b69604d1/cert-joelho-logo.webp",
    "heroTitle": [
      "Domine do início ao fim a Avaliação e Tratamento do Joelho"
    ],
    "heroSub": [
      "Um curso 100% online, com 60h, repleto de",
      "casos clínicos reais e aulas práticas"
    ],
    "ctaHero": "MATRICULE-SE AGORA",
    "cards": [
      {
        "img": "/__l5e/assets-v1/90af3f8e-f9a0-4d71-965a-cc3d3098358d/cert-25ae5b9fe9.webp",
        "lines": [
          "Aprofunde seu raciocínio em conceitos gerais sobre o joelho"
        ]
      },
      {
        "img": "/__l5e/assets-v1/7972dac7-6e12-4166-a76c-4e2782fe5873/cert-73255eee64.webp",
        "lines": [
          "Aprenda com profissionais altamente capacitados e experientes no tema"
        ]
      },
      {
        "img": "/__l5e/assets-v1/f55ec11f-4236-4349-b5a8-124fad763fb6/cert-fcf14e21ed.webp",
        "lines": [
          "Saiba como avaliar e tratar as principais patologias da articulação do Joelho"
        ]
      },
      {
        "img": "/__l5e/assets-v1/a70b1bbf-3a3d-439e-bff2-89b40ca976f3/cert-968425220b.webp",
        "lines": [
          "Exemplos práticos de como atender seus pacientes e casos clínicos reais",
          "Um passo a passo de como transformar seu raciocínio clínico nas patologias do joelho"
        ]
      }
    ],
    "passoTitle": null,
    "stats": [
      {
        "valor": "05",
        "label": "Módulos"
      },
      {
        "valor": "60H",
        "label": "Conteúdos"
      },
      {
        "valor": "80%",
        "label": "Conteúdo Prático"
      }
    ],
    "destaque": [
      "Domine técnicas",
      "comprovadas",
      "cientificamente"
    ],
    "ctaMid": "QUERO ME INSCREVER",
    "mockupSmartphone": "/__l5e/assets-v1/ec6c3a3e-4cf6-4c8e-b46e-eb438ac740c9/cert-13607d1668.webp",
    "expertTitle": null,
    "benefits": [
      {
        "icon": "/__l5e/assets-v1/6c10ea61-93a1-42da-b301-ebd6dd2f223f/cert-bd2198facc.webp",
        "iconAlt": "Escudo.png",
        "lines": [
          "Conquiste segurança",
          "para fazer uma avaliação completa do joelho"
        ]
      },
      {
        "icon": "/__l5e/assets-v1/6a07b1f0-be5c-4ffc-802d-820691898dc2/cert-1be094f95e.webp",
        "iconAlt": "Livro.png",
        "lines": [
          "Melhore seu repertório",
          "com técnicas baseadas",
          "em evidências"
        ]
      },
      {
        "icon": "/__l5e/assets-v1/26218089-9afc-41aa-9e4a-ab6ec516284e/cert-94e5f44572.webp",
        "iconAlt": "Prancheta.png",
        "lines": [
          "Atenda com eficácia seus pacientes e ofereça um tratamento completo"
        ]
      }
    ],
    "fundo": "/__l5e/assets-v1/eaf85338-089f-4756-9d8b-827d63bd4149/cert-7fedd4a36a.webp",
    "comoFuncionaTitle": [
      "Como funciona",
      "a Certificação?"
    ],
    "comoFuncionaText": "É um curso 100% online, com aulas gravadas, para você aprender o que há de mais atual no diagnóstico clínico e nas intervenções para patologias do joelho. Um treinamento recheado de aplicações clínicas e aulas práticas.",
    "comoFuncionaImg": null,
    "aprenderTitle": [
      "O que você vai",
      "aprender?"
    ],
    "modulos": [
      {
        "titulo": "Módulo 1 - Introdução à Certificação do Joelho",
        "itens": []
      },
      {
        "titulo": "Módulo 2 - Avaliação do Joelho: Fundamentos e Roteiro Prático",
        "itens": []
      },
      {
        "titulo": "Módulo 3 - Intervenções na Articulação do Joelho",
        "itens": []
      },
      {
        "titulo": "Módulo 4 - Condições específicas - Tratamento Não-Cirúrgico",
        "itens": []
      },
      {
        "titulo": "Módulo 5 - Protocolos Pós-trauma e Pós-Cirúrgico",
        "itens": []
      }
    ],
    "pilares": [],
    "ctaPilares": null,
    "depoimentos": [
      {
        "quote": "Conteúdo baseado em evidências e professores sempre solícitos para sanar as dúvidas, além de ótimas estratégias de fixação do conteúdo!",
        "foto": null,
        "nome": "Cindy Balansin",
        "role": "Fisioterapeuta"
      }
    ],
    "seloAutoridade": "/__l5e/assets-v1/4000ee2c-7d42-40c4-b39a-a8f6b3bf1651/cert-73fa0432f3.webp",
    "autoridadeTitle": "Aprenda com quem domina o assunto",
    "autoridadeSub": "Descubra como os fisioterapeutas que você mais admira estão fazendo para que você se torne especialista este ano",
    "professores": [],
    "mockupTablet": "/__l5e/assets-v1/5639830f-d148-4d70-80d9-d28fd2956201/cert-1d141a87c8.webp",
    "selo2anos": "/__l5e/assets-v1/ef0c67ea-15c6-4f40-9d39-26ecc1f38ed2/cert-e5879263d5.webp",
    "preco": [
      "DE R$697 POR",
      "10x R$24,70",
      "ou R$247,00 à vista"
    ],
    "promo": [
      "Aproveite o valor promocional!",
      "ÚLTIMOS DIAS - R$450,00 OFF"
    ],
    "checkoutLabel": "MATRICULE-SE",
    "checkoutUrl": "https://chk.eduzz.com/1W32DY3592?cupom=PROMO&df=1&np=10",
    "bonus": [
      "BÔNUS: Ao se matricular você garante R$600,00 de desconto em todas as outras Certificações da FEO.",
      "Desconto aplicado direto no carrinho. Não perca essa chance de mudar sua carreira!"
    ],
    "faqSupport": [
      "Ainda precisa de ajuda? Entre em",
      "contato com o suporte ao cliente!"
    ],
    "suporteLabel": "FALE CONOSCO",
    "suporteUrl": "https://api.whatsapp.com/send?1=pt_BR&phone=5511930316779",
    "faqImg": "/__l5e/assets-v1/92567dc4-97ff-48d2-b5dc-5c3a18f92f72/cert-871f9f89a1.webp",
    "faq": [
      {
        "q": "Por quanto tempo terei acesso à certificação?",
        "a": "O conteúdo completo da Certificação ficará disponível por dois anos contados a partir do momento da sua inscrição."
      },
      {
        "q": "A certificação é somente para fisioterapeutas?",
        "a": "Sim, a certificação foi pensada para fisioterapeutas que já atuam na área e trabalham com pacientes que lidam com condições clínicas relacionadas as patologias do joelho."
      },
      {
        "q": "Como posso tirar dúvidas com os professores?",
        "a": "Você poderá deixar suas dúvidas em nossa plataforma de ensino. As suas perguntas serão respondidas por nossos professores!"
      },
      {
        "q": "Como será a entrega do certificado?",
        "a": "O certificado será entregue após você realizar todas às aulas da Certificação. Você poderá retirá-lo dentro da nossa plataforma de ensino."
      },
      {
        "q": "O conteúdo da Certificação é o mesmo que estão nos cursos da Star?",
        "a": "Não, o conteúdo da Certificação é exclusivo e com uma visão aprofundada para transformar o fisioterapeuta em \"expert\" na temática. São 60h de conteúdos dedicados ao aprofundamento e distribuídos em 5 módulos."
      },
      {
        "q": "Sou estudante, posso fazer a Certificação?",
        "a": "Você pode fazer a Certificação. No entanto, ela é indicada para fisioterapeutas que têm uma demanda no consultório. © 2026 Fisio em Ortopedia. Todos os direitos reservados."
      }
    ],
    "ofertaTitle": "Ofereça o melhor tratamento para os seus pacientes",
    "heroBg": "/__l5e/assets-v1/1402b17b-b63b-41ad-9284-c0be00e5e8bb/quadril-background.webp",
    "comoFuncionaNaSecaoBranca": true,
    "benefitsGrid": [
      {
        "icon": "stethoscope",
        "title": "CONQUISTE SEGURANÇA PARA FAZER UMA AVALIAÇÃO COMPLETA DO JOELHO"
      },
      {
        "icon": "book-open",
        "title": "MELHORE SEU REPERTÓRIO COM TÉCNICAS BASEADAS EM EVIDÊNCIAS"
      },
      {
        "icon": "award",
        "title": "TORNE-SE REFERÊNCIA NO TRATAMENTO DAS PATOLOGIAS DO JOELHO"
      },
      {
        "icon": "heart-pulse",
        "title": "ATENDA COM EFICÁCIA SEUS PACIENTES E OFEREÇA UM TRATAMENTO COMPLETO"
      }
    ]
  },
  "quadril": {
    "slug": "quadril",
    "logo": "/__l5e/assets-v1/09859c87-19f3-469f-8b2a-51a0bf45537c/quadril-logo-oficial.webp",
    "heroBg": "/__l5e/assets-v1/1402b17b-b63b-41ad-9284-c0be00e5e8bb/quadril-background.webp",
    "heroTitle": [
      "Domine do início ao fim a Avaliação e o Tratamento do Quadril"
    ],
    "heroSub": [
      "Um curso 100% online, com 60h, repleto de",
      "casos clínicos reais e aulas práticas"
    ],
    "heroHighlight": [
      "Um curso 100% online repleto de casos clínicos reais e aulas práticas"
    ],
    "heroBelowCta": [
      "Desconto de lançamento + bônus imperdíveis apenas dentro do grupo."
    ],
    "ctaHero": "ENTRAR NO GRUPO DE PRÉ-MATRÍCULA",
    "cards": [
      {
        "img": "/__l5e/assets-v1/a88f6572-7f55-4a74-96e8-b3ca7c88c263/thumb-quadril-01.webp",
        "lines": [
          "Anatomia e biomecânica do quadril conectadas com o raciocínio clínico e a dor"
        ]
      },
      {
        "img": "/__l5e/assets-v1/d71477b8-5630-4c08-88cd-c925e9f7f0b5/thumb-quadril-02.webp",
        "lines": [
          "Avaliação completa: história clínica, testes funcionais, PROMs e exames de imagem"
        ]
      },
      {
        "img": "/__l5e/assets-v1/313ef2b0-ae56-498d-a47f-28a5669b9c0f/thumb-quadril-03.webp",
        "lines": [
          "Intervenções baseadas em evidências, com educação, exercício e terapia manual"
        ]
      },
      {
        "img": "/__l5e/assets-v1/1a3e144c-28c8-407e-9f84-33c5514948fc/thumb-quadril-04.webp",
        "lines": [
          "Reabilitação pós-cirúrgica passo a passo e casos clínicos com tomada de decisão real"
        ]
      }
    ],
    "passoTitle": null,
    "stats": [
      {
        "valor": "06",
        "label": "Módulos"
      },
      {
        "valor": "60H",
        "label": "Conteúdos"
      },
      {
        "valor": "80%",
        "label": "Conteúdo Prático"
      }
    ],
    "destaque": [
      "Domine técnicas",
      "comprovadas",
      "cientificamente"
    ],
    "ctaMid": "QUERO GARANTIR MINHA VAGA",
    "mockupSmartphone": "/__l5e/assets-v1/9256a3a2-d367-4b7a-91ac-1cd86f6cbc4e/selo-certificacao-quadril.webp",
    "expertTitle": null,
    "benefits": [
      {
        "icon": "/__l5e/assets-v1/6c10ea61-93a1-42da-b301-ebd6dd2f223f/cert-bd2198facc.webp",
        "iconAlt": "Escudo",
        "lines": [
          "Conquiste segurança",
          "para fazer uma avaliação completa do quadril"
        ]
      },
      {
        "icon": "/__l5e/assets-v1/6a07b1f0-be5c-4ffc-802d-820691898dc2/cert-1be094f95e.webp",
        "iconAlt": "Livro",
        "lines": [
          "Melhore seu repertório",
          "com técnicas baseadas",
          "em evidências"
        ]
      },
      {
        "icon": "/__l5e/assets-v1/26218089-9afc-41aa-9e4a-ab6ec516284e/cert-94e5f44572.webp",
        "iconAlt": "Prancheta",
        "lines": [
          "Atenda com eficácia seus pacientes e ofereça um tratamento completo"
        ]
      }
    ],
    "benefitsGrid": [
      {
        "icon": "stethoscope",
        "title": "CONQUISTE SEGURANÇA PARA FAZER UMA AVALIAÇÃO COMPLETA DO QUADRIL"
      },
      {
        "icon": "book-open",
        "title": "MELHORE SEU REPERTÓRIO COM TÉCNICAS BASEADAS EM EVIDÊNCIAS"
      },
      {
        "icon": "award",
        "title": "TORNE-SE REFERÊNCIA NO TRATAMENTO DAS PATOLOGIAS DO QUADRIL"
      },
      {
        "icon": "heart-pulse",
        "title": "ATENDA COM EFICÁCIA SEUS PACIENTES E OFEREÇA UM TRATAMENTO COMPLETO"
      }
    ],
    "fundo": "/__l5e/assets-v1/4a76072b-d417-44b6-b8df-cc250084dc2a/quadril-fundo.webp",
    "comoFuncionaTitle": [
      "Como funciona",
      "a Certificação?"
    ],
    "comoFuncionaText": "É um curso 100% online, com aulas gravadas, para você aprender o que há de mais atual no diagnóstico clínico e nas intervenções para patologias do quadril. Um treinamento recheado de aplicações clínicas e aulas práticas.",
    "comoFuncionaImg": "/__l5e/assets-v1/a25d775a-925b-438f-8c17-c10d8e031f22/quadril-anatomia.webp",
    "comoFuncionaNaSecaoBranca": true,
    "aprenderTitle": [
      "O que você vai",
      "aprender?"
    ],
    "modulos": [
      {
        "titulo": "Módulo 1 - Introdução da Certificação de Quadril",
        "itens": [
          "Boas-vindas geral",
          "Formato e conteúdo da certificação",
          "Carga e o Quadril: o movimento acelera ou protege o desgaste articular?"
        ]
      },
      {
        "titulo": "Módulo 2 - Avaliação do quadril: Fundamentos e Roteiro Prático",
        "itens": [
          "Anatomia e Biomecânica Funcional do Quadril",
          "Anatomia Palpatória",
          "Roteiro Geral de Avaliação MSK",
          "Exame de Imagem",
          "Exame de Imagem (Densitometria óssea)",
          "Exame Físico: Inspeção Visual e Funcional",
          "Exame Físico: Testes de Força e ADM",
          "Exame Físico: Testes Neurológicos",
          "Exame Físico: Testes Especiais/Clínicos",
          "Exame Físico: Testes Funcionais e de Performance",
          "Exame Físico: PROMs, Questionários Validados"
        ]
      },
      {
        "titulo": "Módulo 3 - Intervenções na Articulação do Quadril",
        "itens": [
          "Racional: como elaborar um plano de cuidado na Reabilitação do Quadril",
          "Educação em Dor e Saúde nas condições do Quadril",
          "Prescrição de Exercício: Manejo de Carga e Periodização",
          "Prescrição de Exercício: Força, Isometria, Resistência, Pliometria",
          "Prescrição de Exercícios Aeróbicos",
          "Prescrição de exercícios com foco comportamental",
          "Terapia Manual e Terapias Coadjuvantes",
          "Agentes Eletrofísicos"
        ]
      },
      {
        "titulo": "Módulo 4 - Condições específicas - Tratamento Não-Cirúrgico",
        "itens": [
          "Dor Anterior (Impacto Femoro-Acetabular, Lesões do Labrum Articular)",
          "Dor Medial (Pubalgia e Tendinopatia dos Adutores)",
          "Dor Lateral (Sd da Dor do Trocanter Maior / Trato Iliotibial / Tendinopatias de abdutores)",
          "Dor Posterior (Tendinopatia IQT Proximal / Sd do Piriforme / Dor Lombossacra)",
          "Osteoartrite de Quadril",
          "Osteonecrose da Cabeça Femoral (citar Lúpus e Esclerodermia)"
        ]
      },
      {
        "titulo": "Módulo 5 - Condições específicas do Quadril na Infância e Adolescência",
        "itens": [
          "O Desenvolvimento do Quadril",
          "Doenças do Desenvolvimento: Displasia do Desenvolvimento do Quadril (DDQ)",
          "Epifisiólise Proximal do Fêmur",
          "Legg Calvé Perthes"
        ]
      },
      {
        "titulo": "Módulo 6 - Protocolos Pós-trauma e Pós-Cirúrgico",
        "itens": [
          "Princípios do P.O.: Manuseios, Cuidados, Adaptações e descarga de peso no PO hospitalar/clínica domicílio",
          "Princípios do P.O.: Manuseio e Descarga de Peso",
          "Princípios do P.O.: Cuidados e Adaptações no PO clínica/domicílio",
          "Princípios do P.O.: Mobilização precoce hospitalar",
          "Artroscopia do Quadril (IFA, Osteoplastias, Labrum, Reparos Labrais, Capsuloplastia)",
          "Reabilitação Pós-operatória das Fraturas Proximais de Quadril",
          "Reabilitação de Artroplastia Total de Quadril",
          "Osteonecrose da Cabeça Femoral",
          "Osteotomias (Periacetabular / Femoral)"
        ]
      }
    ],
    "pilares": [],
    "ctaPilares": null,
    "depoimentos": [
      {
        "quote": "A certificação foi o primeiro curso mais extenso da plataforma que realizei e superou minhas expectativas. Profissionais excelentes, atualizados, conteúdo muito bem embasado. Pude relembrar muitas coisas, melhorei muito minha avaliação clínica, pude organizar melhor meu tempo e ser mais objetiva.",
        "foto": null,
        "nome": "Pauline",
        "role": "Aluna da FEO"
      },
      {
        "quote": "O que vou levar para a clínica todos os dias é que a forma como classifico meu paciente durante a minha avaliação me ajuda a traçar um plano mais individualizado e específico para suas necessidades.",
        "foto": null,
        "nome": "Ariádne",
        "role": "Aluna da FEO"
      }
    ],
    "seloAutoridade": "/__l5e/assets-v1/32ae8a59-63af-4b7f-a88d-87fcea88ea92/selo-autoridade.webp",
    "autoridadeTitle": "Aprenda com quem domina o assunto",
    "autoridadeSub": "Descubra como os fisioterapeutas que você mais admira estão fazendo para que você se torne especialista este ano",
    "professores": [
      {
        "foto": "/__l5e/assets-v1/2d992165-e9cf-4e09-9b88-0e772907d0c7/prof-adriana-carvalho.webp",
        "nome": "Adriana Carvalho",
        "role": "Professora FEO",
        "bio": []
      },
      {
        "foto": "/__l5e/assets-v1/bee37303-92d6-4085-aa3f-09d2bc538226/prof-barbara-noal-v2.webp",
        "nome": "Bárbara Noal",
        "role": "Professora FEO",
        "bio": []
      },
      {
        "foto": "/__l5e/assets-v1/40e77a1a-01cd-4bfd-b1da-74bd19473bd8/prof-areolino-matos.webp",
        "nome": "Areolino Matos",
        "role": "Professor FEO",
        "bio": []
      },
      {
        "foto": "/__l5e/assets-v1/9f80bb1b-7b76-4e8d-9c3c-9862162c50e1/prof-bruno-gruninger.webp",
        "nome": "Bruno Grüninger",
        "role": "Professor FEO",
        "bio": []
      },
      {
        "foto": "/__l5e/assets-v1/9a07a982-b435-4167-9e9a-274c939e0ed9/prof-cid-gomes.webp",
        "nome": "Cid Gomes",
        "role": "Professor FEO",
        "bio": []
      },
      {
        "foto": "/__l5e/assets-v1/d67d65ac-164a-4c4f-8464-d163160b5a6f/prof-flavio-bryk.webp",
        "nome": "Flávio Bryk",
        "role": "Professor FEO",
        "bio": []
      },
      {
        "foto": "/__l5e/assets-v1/bd1bd7eb-dc7b-4d27-b14e-24ae6c28112c/prof-gislene-gomes.webp",
        "nome": "Gislene Gomes",
        "role": "Professora FEO",
        "bio": []
      },
      {
        "foto": "/__l5e/assets-v1/0264f141-4ffb-4b04-9e29-3b8ddd6c76db/prof-leandro-fukusawa.webp",
        "nome": "Leandro Fukusawa",
        "role": "Professor FEO",
        "bio": []
      },
      {
        "foto": "/__l5e/assets-v1/0d0724c7-9275-49ef-b1d8-02a68fe2d055/prof-luiz-scola.webp",
        "nome": "Luiz Scola",
        "role": "Professor FEO",
        "bio": []
      },
      {
        "foto": "/__l5e/assets-v1/f79043ef-f4f7-492f-8ea8-40c5627e3aa4/prof-nayra-rabelo.webp",
        "nome": "Nayra Rabelo",
        "role": "Professora FEO",
        "bio": []
      }
    ],
    "ofertaTitle": "Entre para o grupo do lançamento",
    "mockupTablet": "/__l5e/assets-v1/2e890cd8-d679-4fd3-8fea-4ca2f4fb6886/mockup-tablet-final.webp",
    "selo2anos": "/__l5e/assets-v1/0c2d1880-4666-44df-ae77-0f629b04755f/selo-2-anos.webp",
    "preco": [
      "OFERTA DE LANÇAMENTO",
      "NO GRUPO",
      "do WhatsApp"
    ],
    "promo": [],
    "checkoutLabel": "ENTRAR NO GRUPO  DE PRÉ-MATRÍCULA",
    "checkoutLabelMobile": "ENTRAR NO GRUPO\nDE PRÉ-MATRÍCULA",
    "checkoutUrl": "",
    "checkoutTitle": "Clique no botão abaixo e entre no grupo de Whatsapp!",
    "checkoutBottomLine1": "Esse lançamento será realizado exclusivamente dentro do grupo de whatsapp. Os primeiros inscritos terão acesso aos melhores bônus.",
    "checkoutBottomLine2": "O link com desconto + bônus será liberado no dia 29/09 às 10h da manhã",
    "bonus": [],
    "faqSupport": [
      "Ainda precisa de ajuda? Entre em contato!"
    ],
    "suporteLabel": "FALE CONOSCO",
    "suporteUrl": "https://api.whatsapp.com/send?1=pt_BR&phone=5511930316779",
    "faqImg": "/__l5e/assets-v1/92567dc4-97ff-48d2-b5dc-5c3a18f92f72/cert-871f9f89a1.webp",
    "faq": [
      {
        "q": "Quando a Certificação em Quadril será lançada?",
        "a": "O lançamento acontecerá em breve. Quem estiver no grupo de WhatsApp será avisado em primeira mão e terá acesso à condição exclusiva de abertura."
      },
      {
        "q": "Por quanto tempo terei acesso à certificação?",
        "a": "O conteúdo completo da Certificação ficará disponível por dois anos contados a partir do momento da sua inscrição."
      },
      {
        "q": "A certificação é somente para fisioterapeutas?",
        "a": "Sim, a certificação foi pensada para fisioterapeutas que já atuam na área e trabalham com pacientes que lidam com condições clínicas relacionadas ao quadril."
      },
      {
        "q": "Como posso tirar dúvidas com os professores?",
        "a": "Você poderá deixar suas dúvidas em nossa plataforma de ensino. As suas perguntas serão respondidas por nossos professores!"
      },
      {
        "q": "Como será a entrega do certificado?",
        "a": "O certificado será entregue após você realizar todas às aulas da Certificação. Você poderá retirá-lo dentro da nossa plataforma de ensino."
      },
      {
        "q": "O conteúdo da Certificação é o mesmo que estão nos cursos da Star?",
        "a": "Não, o conteúdo da Certificação é exclusivo e com uma visão aprofundada para transformar o fisioterapeuta em \"expert\" na temática. São 60h de conteúdos dedicados ao aprofundamento e distribuídos em 6 módulos."
      }
    ]
  }
};

/**
 * Backup da LP da Quadril na fase de grupo (pré-matrícula no WhatsApp).
 * Referência interna para próximos lançamentos com grupo: /certificacao-quadril-grupo.
 */
export const CERT_QUADRIL_GRUPO: CertificacaoData = { ...CERT_DATA.quadril };

// Normaliza ofertas atuais sem modificar os conteúdos pedagógicos ou o backup de grupo.
for (const slug of CERT_SLUGS) {
  const oferta = certOfertaLp(slug);
  CERT_DATA[slug] = {
    ...CERT_DATA[slug],
    preco: [oferta.precoDe, oferta.parcelado, oferta.aVista],
    promo: [],
    checkoutUrl: certCheckoutUrlLp(slug),
  };
}

/** Quadril em venda direta: condição habitual PROMO, R$300 OFF. */
CERT_DATA.quadril = {
  ...CERT_DATA.quadril,
  heroBelowCta: undefined,
  ctaHero: "QUERO GARANTIR MINHA VAGA",
  ofertaTitle: "Garanta seu desconto especial",
  preco: ["DESCONTO ESPECIAL", "R$300 OFF"],
  checkoutLabel: "MATRICULE-SE AGORA",
  checkoutLabelMobile: undefined,
  checkoutUrl: "https://chk.eduzz.com/G96RR16QW1?cupom=PROMO&df=1&pf=1",
  checkoutTitle: "Oferta especial:",
  checkoutBottomLine1: "Ao se matricular você garante R$600 de desconto em todas as outras Certificações da FEO.",
  checkoutBottomLine2: "Desconto aplicado direto no carrinho. Não perca essa chance de mudar sua carreira!",
};
